module.exports = __webpack_public_path__ + "img/icon-question-points.d3e46c6e.svg";